module.exports = __webpack_public_path__ + "img/concatusbj.becadc06.png";